var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoOccupazioneBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 44 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6214 0L43.2429 12.5V37.5L21.6214 50L0 37.5V12.5L21.6214 0Z",
    className: "box"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9352 34.4032L32.8841 19.3419H26.5034V16.8688C26.5034 15.286 25.2174 14 23.6346 14H19.319C17.7362 14 16.4502 15.286 16.4502 16.8688V19.3419H10.0696L9.00612 34.4032C8.9072 35.8129 10.0201 37 11.4298 37H31.5115C32.9212 37 34.0341 35.8005 33.9352 34.4032ZM19.047 16.8688C19.047 16.7204 19.1706 16.5968 19.319 16.5968H23.6346C23.783 16.5968 23.9067 16.7204 23.9067 16.8688V19.2925H19.047V16.8688ZM29.3475 21.9387L27.2701 28.5296H15.6835L13.6061 21.9387H29.3475ZM11.6153 34.4032L12.1964 26.1059L13.7792 31.1263H29.1744L30.7572 26.1059L31.3384 34.4032H11.6153Z",
    className: "symbol"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoOccupazioneBox);
export default __webpack_public_path__ + "static/media/ico-occupazione-box.4e04b45d139a0db06d967b0bad87a7b9.svg";
export { ForwardRef as ReactComponent };